<div class="well">
  <div class="row">
    <div class="col-sm-5">
      <h2>{{ user.uid }}</h2>
      @if (subscribed && (session_user.is_admin || (config.enable_ui && config.enable_ui.newsletters))) {
        <div>
          <button class="btn" (click)="unsubscribe()"><small class="oi oi-envelope-open glyphicon glyphicon-envelope" title="The user is subscribed to the newletters" style="color: green"></small> unsubscribe</button>
        </div>
      }
      @if (!subscribed) {
        <div>
          <button class="btn" (click)="subscribe()"><small class="oi oi-envelope-open glyphicon glyphicon-envelope" title="The user is not subscribed to the newsletter" style="color: red"></small> subscribe</button>
        </div>
      }
      @if (user && user.created_at) {
        <div>
          <small>Created at : {{ user.created_at | date }}</small>
        </div>
      }
      @if (user && user.expiration) {
        <div>
          <small>Expires: {{ user.expiration | date }}</small>
        </div>
      }
      <div>
        Support available at <a href="mailto:{{ config.support }}">{{ config.support }}</a>
      </div>
    </div>
    <div class="col-sm-2">
      @if (session_user.is_admin && (user.status == STATUS_PENDING_APPROVAL || user.status == STATUS_PENDING_EMAIL)) {
        <p-button severity="success" size="small" (onClick)="activate()" label="Activate"></p-button>
      }
      @if (user.status === STATUS_ACTIVE && (session_user.is_admin || user.disable_extend === false)) {
        <p-button label="Extend" severity="success" size="small" (onClick)="extend()"> </p-button>
      }
      @if (session_user.is_admin && user.status == STATUS_EXPIRED) {
        <p-button severity="success" size="small" (onClick)="renew()" label="Renew"></p-button>
      }
    </div>
    @if (user.is_locked && session_user.is_admin) {
      <div class="col-sm-2">
        <p-button severity="primary" size="small" (onClick)="unlock()" label="Unlock"></p-button>
      </div>
    }
    <div class="col-sm-3">
      @if (session_user.is_admin && (user.status == STATUS_PENDING_APPROVAL || user.status == STATUS_PENDING_EMAIL)) {
        <div><app-my-delete-confirm [onConfirm]="delete" [data]="" [explainMessage]="true"></app-my-delete-confirm></div>
      }
      @if (session_user.is_admin && user.status == STATUS_ACTIVE) {
        <div><app-my-expire-confirm [mailer]="config.mailer" [onConfirm]="expire"></app-my-expire-confirm></div>
      }
      @if (session_user.is_admin && user.status == STATUS_EXPIRED) {
        <div><app-my-delete-confirm [onConfirm]="delete" [data]="" [explainMessage]="true"></app-my-delete-confirm></div>
      }
    </div>
  </div>
</div>

@for (template of plugins; track template) {
  <div>
    @if (plugin_data[template.name] && plugin_data[template.name].warnings && plugin_data[template.name].warnings.length > 0) {
      <div class="alert alert-warning">
        @for (warning of plugin_data[template.name].warnings; track warning) {
          <div><strong>Warning!</strong> {{ warning }}</div>
        }
      </div>
    }
    @if (plugin_data[template.name] && plugin_data[template.name].errors && plugin_data[template.name].errors.length > 0) {
      <div class="alert alert-danger">
        @for (error of plugin_data[template.name].errors; track error) {
          <div><strong>Alert!</strong> {{ error }}</div>
        }
      </div>
    }
  </div>
}

@if (msg) {
  <div class="alert alert-success" role="alert">{{ msg }}</div>
}
@if (del_msg) {
  <div class="alert alert-warning" role="alert">{{ del_msg }}</div>
}
@if (err_msg) {
  <div class="alert alert-danger" role="alert">{{ err_msg }}</div>
}

<div class="card text-center">
  <div class="card-header">
    <ul class="nav nav-pills card-header-pills">
      <li class="nav-item" (click)="switchTo(0)">
        <p-button size="small" styleClass="-outline-primary nav-link" label="Information"></p-button>
      </li>
      <li class="nav-item" (click)="switchTo(1)">
        <p-button size="small" styleClass="-outline-primary nav-link" label="SSH"></p-button>
      </li>
      <li class="nav-item" (click)="switchTo(2)">
        <p-button size="small" styleClass="-outline-primary nav-link" label="Details"></p-button>
      </li>
      <li class="nav-item" (click)="switchTo(3)">
        <p-button size="small" styleClass="-outline-primary nav-link" label="History"></p-button>
      </li>
      @if (session_user.is_admin) {
        <li class="nav-item" (click)="switchTo(4)">
          <p-button size="small" styleClass="-outline-primary nav-link" label="Send mail"></p-button>
        </li>
      }
    </ul>
  </div>

  <div class="card-body">
    <div class="row">
      @if (panel == 0) {
        <div class="col-sm-6">
          <div class="card bg-light">
            <div class="card-header">
              <h4>Information</h4>
            </div>
            <div class="card-body">
              <div class="user-information">
                <form aria-label="user information" role="form" class="user-form form-horizontal form-register">
                  <div class="form-group row">
                    <label for="firstname" class="col-4 col-form-label">First name</label>
                    <div class="col-8">
                      <input type="text" id="firstname" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.firstname" class="form-control" />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="lastname" class="col-4 col-form-label">Last name</label>
                    <div class="col-8">
                      <input type="text" id="lastname" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.lastname" class="form-control" />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="email" class="col-4 col-form-label label-control">Email</label>
                    <div class="col-8">
                      <input type="email" id="email" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.email" class="form-control" />
                    </div>
                  </div>
                  @if (session_user.is_admin) {
                    <div class="form-group row">
                      <label for="key" class="col-4 col-form-label">Email domain</label>
                      <div class="col-8">
                        <input type="text" id="key" [ngModelOptions]="{ standalone: true }" [(ngModel)]="emailDomain" class="form-control" readonly />
                      </div>
                    </div>
                  }
                  <div class="form-group row">
                    <label for="address" class="col-4 col-form-label">Address</label>
                    <div class="col-8">
                      <textarea id="address" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.address" class="form-control"></textarea>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="why" class="col-4 col-form-label">Why</label>
                    <div class="col-8">
                      <textarea id="why" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.why" class="form-control"></textarea>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="lab" class="col-4 col-form-label">Laboratory</label>
                    <div class="col-8">
                      <input type="text" id="lab" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.lab" class="form-control" />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="responsible" class="col-4 col-form-label">Manager</label>
                    <div class="col-8">
                      <input type="text" id="responsible" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.responsible" class="form-control" />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="team" class="col-4 col-form-label">Team</label>
                    <div class="col-8">
                      <input type="text" id="team" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.team" class="form-control" />
                    </div>
                  </div>
                  @if (session_user.is_admin) {
                    <div>
                      <div class="form-group row">
                        <label for="key" class="col-4 col-form-label">Key</label>
                        <div class="col-8">
                          <input type="text" id="key" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.regkey" class="form-control" readonly />
                        </div>
                      </div>
                      @if (config.enable_ui && config.enable_ui.user_group) {
                        <div class="form-group row">
                          <label for="group" class="col-4 col-form-label">Group</label>
                          <div class="col-8">
                            <input disabled type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.group" class="form-control" />
                          </div>
                        </div>
                      }
                      @if (config.enable_ui && config.enable_ui.user_group) {
                        <div class="form-group row">
                          <div class="col-4 col-form-label"></div>
                          <div class="col-6">
                            <select [(ngModel)]="user.group" [ngModelOptions]="{ standalone: true }" class="form-control">
                              @for (group of groups; track group) {
                                <option [ngValue]="group.name">{{ group.new ? group.name + " (new group)" : group.name }}</option>
                              }
                            </select>
                            @if (grp_success_msg) {
                              <div class="alert alert-success">{{ grp_success_msg }}</div>
                            }
                            @if (grp_err_msg) {
                              <div class="alert alert-danger">{{ grp_err_msg }}</div>
                            }
                          </div>
                          @if (user.group == this.missing_group) {
                            <div class="groupCreation col-2">
                              <div>
                                <p-button severity="primary" size="small" type="button" data-bs-toggle="modal" data-bs-target="#group_creation">
                                  <span class="oi oi-plus" aria-hidden="true"></span>
                                </p-button>
                              </div>
                            </div>
                          }
                        </div>
                      }
                      @if (config.enable_ui && config.enable_ui.main_group) {
                        <div class="form-group row">
                          <label for="mgroup" class="col-4 col-form-label">Main group directory</label>
                          <div class="col-8">
                            <select id="mgroup" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.maingroup" class="form-control">
                              @for (item of config.main_groups; track item) {
                                <option [value]="item">{{ item }}</option>
                              }
                            </select>
                          </div>
                        </div>
                      }
                      @if (user.secondarygroups && user.secondarygroups.length > 0) {
                        <div class="form-group row">
                          <label label for="sgroup" class="col-4 col-form-label">Secondary groups</label>
                          <div class="col-8">
                            @for (secondary_group of user.secondarygroups; track secondary_group) {
                              <div>
                                <input type="text" [ngModelOptions]="{ standalone: true }" [value]="secondary_group" class="form-control" readonly />
                              </div>
                            }
                          </div>
                        </div>
                      }
                      @if (config.enable_ui && config.enable_ui.ip) {
                        <div class="form-group row">
                          <label for="ip" class="col-4 col-form-label">IP address</label>
                          <div class="col-8">
                            <input type="text" id="ip" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.ip" class="form-control" />
                          </div>
                        </div>
                      }
                      <div class="form-group row">
                        <label for="loginShell" class="col-4 col-form-label">Shell</label>
                        <div class="col-8">
                          <input type="text" id="loginShell" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.loginShell" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="duration" class="col-4 col-form-label">Duration</label>
                        <div class="col-8">
                          <select [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.duration" class="form-control">
                            @for (duration of config.duration; track duration) {
                              <option>{{ duration }}</option>
                            }
                          </select>
                        </div>
                      </div>
                      <div class="form-check row">
                        <input id="staff" name="staff" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.is_internal" type="checkbox" class="form-check-input" />
                        <label class="col-8 form-check-label" for="staff">Staff member</label>
                      </div>
                      <div class="form-check row">
                        <input [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.is_fake" type="checkbox" class="form-check-input" />
                        <label class="col-8 form-check-label">Fake/App account</label>
                      </div>
                      <div class="form-check row">
                        <input [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.never_expire" type="checkbox" class="form-check-input" />
                        <label class="col-8 form-check-label">Never expire</label>
                      </div>
                      <div class="form-check row">
                        <input [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.is_trainer" type="checkbox" class="form-check-input" />
                        <label class="col-8 form-check-label">Trainer account</label>
                      </div>
                      <div class="form-check row">
                        <input [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.send_copy_to_support" type="checkbox" class="form-check-input" />
                        <label class="col-8 form-check-label">Copy mail to Support Team</label>
                      </div>
                      <div class="form-check row">
                        <input [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.disable_extend" type="checkbox" class="form-check-input" />
                        <label class="col-8 form-check-label">Disable user self-extend rights</label>
                      </div>
                    </div>
                  }
                  @if (!session_user.is_admin) {
                    <div>
                      <div class="form-group">
                        <label for="group" class="col-4 col-form-label">Group</label>
                        <div class="col-8">
                          <input type="text" id="group" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.group" class="form-control" readonly />
                        </div>
                      </div>
                      <div class="form-group">
                        @if (user.secondarygroups && user.secondarygroups.length > 0) {
                          <label label for="sgroup" class="col-4 col-form-label">Secondary groups</label>
                        }
                        <div class="col-8">
                          @for (secondary_group of user.secondarygroups; track secondary_group) {
                            <div>
                              <input type="text" id="{{ secondarygroup }}" [ngModelOptions]="{ standalone: true }" [value]="secondary_group" class="form-control" readonly />
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </form>
              </div>
              @if (update_msg) {
                <div class="alert alert-success" role="alert">{{ update_msg }}</div>
              }
              @if (update_error_msg) {
                <div class="alert alert-danger" role="alert">{{ update_error_msg }}</div>
              }
              <p-button severity="primary" size="small" type="button" styleClass="  pull-right" (onClick)="update_info()" label="Update info"></p-button>
            </div>
          </div>
          @if (user && user.extra_info) {
            <div class="card bg-light">
              <div class="card-header"><h4>Extra information</h4></div>
              <div class="card-body">
                <app-user-extra [user]="user" (extraValues)="onExtraValue($event)"></app-user-extra>
                @if (update_msg) {
                  <div class="alert alert-success" role="alert">{{ update_msg }}</div>
                }
                @if (update_error_msg) {
                  <div class="alert alert-danger" role="alert">{{ update_error_msg }}</div>
                }
                <p-button severity="primary" size="small" type="button" styleClass="  pull-right" (onClick)="update_info()" label="Update info"></p-button>
              </div>
            </div>
          }
        </div>
      }

      @if (panel == 0) {
        <div class="col-sm-6">
          @if (session_user.is_admin) {
            <div class="card bg-light">
              <div class="card-header">
                <h4>Tags</h4>
              </div>
              <div class="card-body">
                <app-tag [tag]="user.tags" [user]="user.uid" kind="user"></app-tag>
              </div>
            </div>
          }
          @if (session_user.is_admin && config.enable_ui && config.enable_ui.log) {
            <div class="card bg-light">
              <div class="card-header">
                <h4>Note</h4>
              </div>
              <div class="card-body">
                @if (err_note) {
                  <div class="alert alert-danger" role="alert">{{ err_note }}</div>
                }
                <div class="form-group">
                  <textarea class="form-control" [ngModelOptions]="{ standalone: true }" [(ngModel)]="note"></textarea>
                </div>
                <div class="form-group">
                  <p-button severity="primary" size="small" type="button" (onClick)="add_note()" label="Add note"></p-button>
                </div>
              </div>
            </div>
          }
          @if (user.u2f && config.enable_ui && config.enable_ui.u2f_key) {
            <div class="card bg-light">
              <div class="card-header">
                <h4>Authentication</h4>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-12" style="margin-bottom: 10px">
                    @if (user.u2f.key) {
                      <span><span class="glyphicon glyphicon-ok"> </span> Using Webauthn key</span>
                    }
                    <p-button severity="primary" size="small" styleClass="  btn-sm" (onClick)="register_u2f()" label="Register new key"></p-button>
                    @if (u2f) {
                      <span>{{ u2f }}</span>
                    }
                  </div>
                  <div class="col-sm-12">
                    @if (!((user.otp && user.otp.secret) || otp)) {
                      <p-button severity="primary" size="small" styleClass="  btn-sm" (onClick)="register_otp()" label="Register OTP"></p-button>
                    }
                    @if (user.otp && user.otp.secret) {
                      <p-button severity="danger" size="small" styleClass="  btn-sm" (onClick)="remove_otp()" label="Remove OTP"></p-button>
                    }
                    @if (otp) {
                      <img alt="{{ secret }}" src="{{ otp }}" />
                    }
                    @if (msg) {
                      <div class="alert alert-success" role="alert">{{ otp_msg }}</div>
                    }
                    @if (err_msg) {
                      <div class="alert alert-danger" role="alert">{{ otp_err_msg }}</div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="card bg-light">
            <div class="card-header">
              <h4>API Key</h4>
            </div>
            <div class="card-body">
              <span>{{ user.apikey }}</span>
              <p-button severity="primary" size="small" style="margin-left: 10px" (onClick)="generate_apikey(user.uid)" label="Generate"></p-button>
            </div>
          </div>
          <div class="card bg-light">
            <div class="card-header">
              <h4>Home directory</h4>
            </div>
            <div class="card-body">
              <span>{{ user.home }}</span>
            </div>
          </div>
          <div class="card bg-light">
            <div class="card-header">
              <h4>Update password</h4>
            </div>
            <div class="card-body">
              @if (update_passwd) {
                <div class="alert alert-success">{{ update_passwd }}</div>
              }
              <form>
                <div class="form-group row">
                  <div class="col-sm-8">
                    <input [value]="user.uid" id="user_id" type="text" autocomplete="username" hidden readonly />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-8 offset-sm-2">
                    <label for="password" class="col-form-label">New password</label>
                    <div class="input-group password-field">
                      <input autocomplete="new-password" id="password" placeholder="New password" [type]="passwordVisible ? 'text' : 'password'" [ngModelOptions]="{ standalone: true }" [(ngModel)]="password1" #password1Model="ngModel" name="password1" class="form-control" required minlength="12" (input)="checkPasswordRules(password1)" (blur)="validateInput(password1Model)" />
                      <div class="input-group-append">
                        <i class="toggle-password pi" [ngClass]="passwordVisible ? 'pi-eye-slash' : 'pi-eye'" (click)="togglePasswordVisibility(1)" aria-label="Toggle password visibility" role="button" tabindex="0"></i>
                        @if (isFormValid() && password1Model.dirty && password1.length > 0) {
                          <span class="input-group-text valid-indicator"> &#10003; </span>
                        }
                        @if (!isFormValid() && password1Model.dirty && password1.length > 0) {
                          <span class="input-group-text invalid-indicator"> &#10007; </span>
                        }
                      </div>
                    </div>
                    <div class="password-rules mt-2">
                      <p>Password rules requirements:</p>
                      <div [ngClass]="{ 'rule-satisfied': passwordLengthValid, 'rule-not-satisfied': !passwordLengthValid }">- 12 characters minimum</div>
                      <div [ngClass]="{ 'rule-satisfied': hasDigit, 'rule-not-satisfied': !hasDigit }">- At least one digit</div>
                      <div [ngClass]="{ 'rule-satisfied': hasLowercase, 'rule-not-satisfied': !hasLowercase }">- At least one lowercase letter</div>
                      <div [ngClass]="{ 'rule-satisfied': hasUppercase, 'rule-not-satisfied': !hasUppercase }">- At least one uppercase letter</div>
                      <div [ngClass]="{ 'rule-satisfied': hasSpecialChar, 'rule-not-satisfied': !hasSpecialChar }">- At least one special character</div>
                      <div [ngClass]="{ 'rule-satisfied': !hasSpaces, 'rule-not-satisfied': hasSpaces }">- No spaces allowed</div>
                    </div>
                  </div>
                  <div class="col-sm-8 offset-sm-2 mt-3">
                    <label for="confirm_password" class="col-form-label">Confirm password</label>
                    <div class="input-group password-field">
                      <input autocomplete="new-password" id="confirm_password" placeholder="Confirm password" [type]="passwordConfirmVisible ? 'text' : 'password'" [ngModelOptions]="{ standalone: true }" [(ngModel)]="password2" #password2Model="ngModel" name="password2" class="form-control" required (blur)="validateInput(password2Model)" (input)="checkPasswordMatch(password1Model, password2Model)" />
                      <div class="input-group-append">
                        <i class="toggle-password pi" [ngClass]="passwordConfirmVisible ? 'pi-eye-slash' : 'pi-eye'" (click)="togglePasswordVisibility(2)" aria-label="Toggle password visibility" role="button" tabindex="0"></i>
                        @if (password1Model.valid && password2Model.valid && password1 === password2 && password2.length > 0) {
                          <span class="input-group-text valid-indicator"> &#10003; </span>
                        }
                        @if ((password2Model.dirty || password2Model.touched) && (password1Model.invalid || password1 !== password2) && password2.length > 0) {
                          <span class="input-group-text invalid-indicator"> &#10007; </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <p-button severity="primary" size="small" type="button" class="  mt-3" (onClick)="update_password(password1Model, password2Model)" [disabled]="!isFormValid() || password1 !== password2" [ngstyleClass]="{ 'btn-disabled': !isFormValid() || password1 !== password2 }" label="Change password"></p-button>
              </form>
            </div>
          </div>
          @if (session_user.is_admin) {
            <div class="card bg-light">
              <div class="card-header">
                <h4>Secondary groups</h4>
              </div>
              <div class="card-body">
                @if (add_group_msg) {
                  <div class="alert alert-success alert-dismissible" role="alert">
                    {{ add_group_msg }}
                    <p-button type="button" styleClass="close" data-dismiss="alert" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </p-button>
                  </div>
                }
                @if (rm_group_msg) {
                  <div class="alert alert-warning alert-dismissible" role="alert">
                    {{ rm_group_msg }}
                    <p-button type="button" styleClass="close" data-dismiss="alert" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </p-button>
                  </div>
                }
                <div class="form-group row">
                  <div class="col-sm-6">
                    <label for="newgroup" class="col-form-label">Groups</label>
                    <select id="newgroup" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.newgroup" class="form-control">
                      @for (group of groups; track group) {
                        <option [ngValue]="group.name">{{ group.name }}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <p-button severity="primary" size="small" type="button" (onClick)="add_secondary_group()" label="Add to group"></p-button>
                </div>
                <hr />
                <div class="table-responsive">
                  @if (user.secondarygroups && user.secondarygroups.length > 0) {
                    <table aria-label="secondary groups" class="table table-striped">
                      <thead>
                        <th scope="col">Name</th>
                        <th scope="col"></th>
                      </thead>
                      <tbody>
                        @for (secondary_group of user.secondarygroups; track secondary_group) {
                          <tr>
                            <td>{{ secondary_group }}</td>
                            <td><app-my-delete-confirm [onConfirm]="delete_secondary_group" [data]="secondary_group"></app-my-delete-confirm></td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                </div>
              </div>
            </div>
          }
          @if (session_user.is_admin && user.projects) {
            <div class="card bg-light">
              <div class="card-header">
                <h4>Projects</h4>
              </div>
              <div class="card-body">
                <app-user-projects [projects]="new_projects" [user_projects]="user_projects" [user]="user"></app-user-projects>
              </div>
            </div>
          }
          @if (config.enable_ui && config.enable_ui.databases) {
            <div class="card bg-light">
              <div class="card-header">
                <h4>Databases</h4>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  @if (databases && databases.length > 0) {
                    <table aria-label="databases" class="table table-striped">
                      <thead>
                        <th scope="col">Name</th>
                      </thead>
                      <tbody>
                        @for (db of databases; track db) {
                          <tr>
                            <td>{{ db.name }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }

      @if (panel == 1) {
        <div class="col-md-6 col-sm-12">
          <div class="card bg-light">
            <div class="card-header">
              <h4>Add public SSH key</h4>
            </div>
            <div class="card-body">
              @if (ssh_message) {
                <div class="alert alert-success alert-dismissible" role="alert">
                  {{ ssh_message }}
                  <p-button type="button" styleClass="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </p-button>
                </div>
              }
              <div>
                <form aria-label="ssh key" role="form" class="user-form form-inline">
                  <div class="form-group">
                    <input placeholder="SSH public key (one line)" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="user.ssh" class="form-control" />
                  </div>
                  <div class="form-group">
                    <p-button severity="primary" size="small" type="button" (onClick)="update_ssh()" label="Add"></p-button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }

      @if (panel == 1) {
        <div class="col-md-6 col-sm-12">
          <div class="card bg-light">
            <div class="card-header">
              <h4>SSH keys</h4>
            </div>
            <div class="card-body">
              <div class="alert alert-info" role="alert">When generating a key, public key is automatically added to authorized keys, process takes one minute</div>
              @if (key_err) {
                <div class="alert alert-warning alert-dismissible fade show" role="alert">{{ key_err }}</div>
              }
              @if (new_key_message) {
                <div class="alert alert-success">{{ new_key_message }}</div>
              }
              <p-button severity="primary" size="small" (onClick)="ssh_new_key()" label="Generate new key"></p-button>
              <hr />
              <h4 style="font-weight: normal">Download</h4>
              <p-button severity="primary" size="small" (onClick)="get_key(user.uid, 'private')" label="private rsa key"></p-button>
              <p-button severity="primary" size="small" (onClick)="get_key(user.uid, 'putty')" label="putty private key"></p-button>
              <p-button severity="primary" size="small" (onClick)="get_key(user.uid, 'public')" label="public key"></p-button>
            </div>
          </div>
        </div>
      }

      @if (panel == 2) {
        <div class="col-12">
          <div class="row">
            @if (panel == 2) {
              <div class="col-md-6 col-sm-12">
                @if (config.enable_ui && config.enable_ui.websites) {
                  <div class="card bg-light">
                    <div class="card-header">
                      <h4>Web sites</h4>
                    </div>
                    <div class="card-body">
                      @if (session_user.is_admin) {
                        <div>
                          @if (webmsg) {
                            <div class="alert alert-success alert-dismissible" role="alert">
                              {{ webmsg }}
                              <p-button type="button" styleClass="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                              </p-button>
                            </div>
                          }
                          @if (rmwebmsg) {
                            <div class="alert alert-warning alert-dismissible" role="alert">
                              {{ rmwebmsg }}
                              <p-button type="button" styleClass="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                              </p-button>
                            </div>
                          }
                          <div class="form-group row">
                            <div class="col-sm-6">
                              <label for="website_name">Web site name</label>
                              <input placeholder="alphanumeric" id="website_name" type="text" class="form-control" [ngModelOptions]="{ standalone: true }" [(ngModel)]="website.name" />
                              <label for="website_url">Web site url</label>
                              <input type="text" id="website_url" class="form-control" [ngModelOptions]="{ standalone: true }" [(ngModel)]="website.url" />
                              <label for="website_description">Web site short description</label>
                              <input id="website_description" type="text" class="form-control" [ngModelOptions]="{ standalone: true }" [(ngModel)]="website.description" />
                            </div>
                          </div>
                          <div class="form-group">
                            <p-button severity="primary" size="small" type="button" (onClick)="web_add()" label="Declare owned site"></p-button>
                          </div>
                        </div>
                      }
                      <div>
                        <hr />
                        <div class="table-responsive">
                          @if (websites && websites.length > 0) {
                            <table aria-label="web sites" class="table table-striped">
                              <thead>
                                <th scope="col">Name</th>
                                <th scope="col">Url</th>
                                <th scope="col">Description</th>
                                <th scope="col"></th>
                              </thead>
                              <tbody>
                                @for (site of websites; track site) {
                                  <tr>
                                    <td>{{ site.name }}</td>
                                    <td>{{ site.url }}</td>
                                    <td>{{ site.description }}</td>
                                    <td><app-my-delete-confirm [onConfirm]="web_delete" [data]="site.name"></app-my-delete-confirm></td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
            @for (template of plugins; track template) {
              <div class="col-md-6 col-sm-12">
                @if (!template.admin_only || session_user.is_admin) {
                  <div class="card bg-light">
                    <div class="card-header">
                      <h4>{{ template.display_name }}</h4>
                    </div>
                    <div class="card-body">
                      <app-plugin [pluginItem]="template.name" [userId]="user.uid"></app-plugin>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }

      @if (panel == 3) {
        <div class="col-12">
          <div class="card bg-light">
            <div class="card-header">
              <h4>History</h4>
            </div>
            <div class="card-body">
              <app-userlogs [user]="user.uid"></app-userlogs>
            </div>
          </div>
        </div>
      }

      @if (session_user.is_admin && panel == 4) {
        <div class="col-md-6 col-sm-12">
          <div class="card bg-light">
            <div class="card-header">
              <h4>Send message to user</h4>
            </div>
            <div class="card-body">
              @if (notify_err) {
                <div class="alert alert-danger" role="alert">{{ notify_err }}</div>
              }
              <div class="form-group">
                <input class="form-control" [ngModelOptions]="{ standalone: true }" [(ngModel)]="notify_subject" placeholder="mail subject" />
              </div>
              <div class="form-group">
                <textarea class="form-control" [ngModelOptions]="{ standalone: true }" [(ngModel)]="notify_message" placeholder="mail message in markdown"></textarea>
              </div>
              <div class="form-group">
                <p-button severity="primary" size="small" type="button" (onClick)="sendmail()" label="Send mail"></p-button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal" style="z-index: 1500" id="group_creation" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="panel-title">Group creation</h3>
      </div>
      <div class="modal-body">
        <form role="form" class="user-form form-inline justify-content-center">
          <div class="form-group">
            <input placeholder="Group name" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_group.name" class="form-control" />
            <input placeholder="Description" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_group.description" class="form-control" />
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <p-button severity="primary" size="small" type="button" [disabled]="!new_group.name" data-bs-dismiss="modal" (onClick)="addGroup()" label="Create"></p-button>
        <p-button severity="secondary" size="small" type="button" data-bs-dismiss="modal" label="Close"></p-button>
      </div>
    </div>
  </div>
</div>
